'use client';

import { c as _c } from "react/compiler-runtime";
export type ServiceCatalogBodyProps = React.ComponentProps<'div'>;
function ServiceCatalogBody(t0) {
  const $ = _c(8);
  let children;
  let className;
  let props;
  if ($[0] !== t0) {
    ({
      children,
      className,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = children;
    $[2] = className;
    $[3] = props;
  } else {
    children = $[1];
    className = $[2];
    props = $[3];
  }
  let t1;
  if ($[4] !== children || $[5] !== className || $[6] !== props) {
    t1 = <div className={className} {...props}>{children}</div>;
    $[4] = children;
    $[5] = className;
    $[6] = props;
    $[7] = t1;
  } else {
    t1 = $[7];
  }
  return t1;
}
export { ServiceCatalogBody };